import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactDOM from 'react-dom';
import Demo from './demo';
import './index.css';

const { URL, navigator } = window;

ReactDOM.render(
  <Demo
    url={new URL(window.location).searchParams.get('url')}
  />,
  document.querySelector('#demo'),
);

if ('serviceWorker' in navigator) {
  (async () => {
    const registration = await navigator.serviceWorker.ready;
    registration.unregister();
  })();
}



// WEBPACK FOOTER //
// ./demo/src/index.js